import { Location } from '@angular/common';
import { ChangeDetectorRef, Directive, inject, OnDestroy, OnInit, TemplateRef, ViewContainerRef, ViewRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Meta } from '@df/core/meta/meta';
import { Subscription } from 'rxjs';

@Directive()
export abstract class IfCheckoutProcessDirectiveDef implements OnInit, OnDestroy {
    protected hasView = false;
    private templateRef = inject(TemplateRef<any>);
    private viewContainerRef = inject(ViewContainerRef);
    private location = inject(Location);
    protected router = inject(Router);
    private changeDetectorRef = inject(ChangeDetectorRef);
    private meta = inject(Meta);
    protected path: string = this.location.path();
    protected subscriptions: Subscription = new Subscription();

    protected lastConditionValue?: boolean;

    /**
     * Subscribes to router changes and runs initial check
     */
    ngOnInit() {
        this.subscriptions.add(
            this.meta.routerEvents.subscribe(routerEvent => {
                if (routerEvent instanceof NavigationEnd) {
                    this.path = this.router.url;
                    if (this.updateView() && !(<ViewRef>this.changeDetectorRef).destroyed) {
                        this.changeDetectorRef.detectChanges();
                    }
                }
            })
        );
        this.updateView();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    get condition() {
        return this.check();
    }

    /**
     * Check url
     */
    protected check(): boolean {
        return !!this.path.match(/^\/checkout/);
    }

    private updateView() {
        const condition = this.condition;
        if (!!this.lastConditionValue === condition) {
            return false;
        }
        this.lastConditionValue = condition;
        if (this.condition && !this.hasView) {
            this.viewContainerRef.createEmbeddedView(this.templateRef, this);
            this.hasView = true;
        } else if (!this.condition && this.hasView) {
            this.viewContainerRef.clear();
            this.hasView = false;
        }
        return true;
    }
}
